import { Link } from 'gatsby';
import React from 'react';
import { isBrowser } from './isBrowser';

const isInternalURL = (to) => {
  if (!isBrowser) {
    return false;
  }

  try {
    const url = new URL(to, window.location.origin);
    return url.hostname === window.location.hostname;
  } catch {
    return false;
  }
};

export default function CustomLink({ to, children, ...rest }) {
  const isInternal = isInternalURL(to);

  if (isInternal) {
    const url = new URL(to, window.location.origin);
    return (
      <Link to={`${url.pathname.replace(/\/$/, '')}/`} {...rest}>
        {children}
      </Link>
    );
  }
  return (
    <a href={to} target="_blank" rel="noopener noreferrer" {...rest}>
      {children}
    </a>
  );
}
